import { Box, Button, Modal, ModalBody, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { useEffect, useState } from 'react'
import useMobile from '../../hooks/useMobile'

interface ForceUpdateModalProps {
  isOpen: boolean
}

const ForceUpdateModal: React.FC<ForceUpdateModalProps> = ({ isOpen }) => {
  const isMobile = useMobile(600)
  const [platform, setPlatform] = useState<string>('web')

  useEffect(() => {
    // Get platform on mount
    const currentPlatform = Capacitor.getPlatform()
    setPlatform(currentPlatform)
  }, [])

  const handleUpdate = async () => {
    const currentPlatform = Capacitor.getPlatform()

    if (currentPlatform === 'ios') {
      // iOS App Store URL - replace with your actual App Store ID
      // Format: https://apps.apple.com/app/id{APP_STORE_ID}
      const appStoreUrl = 'https://apps.apple.com/app/id6504628408' // TODO: Replace with actual App Store ID
      await Browser.open({ url: appStoreUrl })
    } else if (currentPlatform === 'android') {
      // Android Play Store URL
      // Format: https://play.google.com/store/apps/details?id={PACKAGE_NAME}
      const playStoreUrl = 'https://play.google.com/store/apps/details?id=auth.club.lvbl'
      await Browser.open({ url: playStoreUrl })
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing
      size={isMobile ? 'full' : 'md'}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent p="0" borderRadius={isMobile ? '0' : '10px'}>
        <ModalBody p="30px">
          <VStack spacing="20px" align="stretch" mt="300px">
            <Box
              alignSelf="center"
              bgImage="/logo_black.svg"
              bgRepeat="no-repeat"
              w="100px"
              h="100px"
              bgPos="center"
              bgSize="contain"
            />
            <Text
              variant="cardTitle"
              position="absolute"
              left={isMobile ? '15px' : '30px'}
              bottom={isMobile ? '71px' : '86px'}
              fontFamily="Avenir Next"
              fontStyle="italic"
              fontWeight={700}
            >
              Update Required
            </Text>

            <Text variant="subtle" fontSize={isMobile ? 'md' : 'lg'} textAlign="center" lineHeight="1.6">
              A new version of the app is available. Please update to continue using LVBL.
            </Text>

            {(platform === 'ios' || platform === 'android') && (
              <Button variant="heavy" size="lg" onClick={handleUpdate} w="100%" mt="10px">
                Update Now
              </Button>
            )}

            {platform === 'web' && (
              <Text variant="subtle" fontSize="sm" textAlign="center" color="gray.500">
                Please update the app from your device's app store.
              </Text>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ForceUpdateModal
